import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { Authn } from "../authn";
import { NotFound } from "@effect/platform/HttpApiError";
import { User } from "../../../schema/models";
export default HttpApiGroup.make("usersv1").annotate(OpenApi.Title, "Users V1").annotate(OpenApi.Description, "Endpoints to get user information").add(HttpApiEndpoint.get("getSelf", "/self").addSuccess(User.Model).addError(NotFound).annotateContext(OpenApi.annotations({
    summary: "Get Self"
}))).prefix("/v1/users").middleware(Authn);
